var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:'flex justify-center items-center px-4 py-3 rounded ' + 
                (_vm.activated ? ' bg-blue-100 ' :'  hover:bg-blue-50 '),on:{"click":_vm.onClick}},[_c('span',{class:(_vm.activated ? ' text-blue-500 ' : ' text-gray-600 ') +' text-sm whitespace-nowrap  '},[_vm._v(_vm._s(_vm.menu.meta.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }